import { render } from "./tooltip.md?vue&type=template&id=bc3cf484"
import script from "./tooltip.md?vue&type=script&lang=js"
export * from "./tooltip.md?vue&type=script&lang=js"
script.render = render

export default script